export enum SocialShareIcon {
    facebook = 'facebook',
    messenger = 'messenger',
    whatsapp = 'whatsapp',
    email = 'email'
  }
  